import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ChatGroup } from '@models/Chat/ChatGroup';
import { GroupMsg } from '@models/Chat/GroupMsg';
import { Subject } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import * as io from 'socket.io-client';

interface DeleteMsgSignal {
  group_id: string;
  msg_id: string;
}

@Injectable()
export class GroupChatSocketService {
  private socket: io.Socket;
  private newMsg = new Subject<GroupMsg>();
  private delMsg = new Subject<DeleteMsgSignal>();

  connect(token: string) {
    if (token && !this.socket) {
      this.socket = io.connect(environment.backend + '/groupchat', {
        path: '/socket.io-client',
        query: { token },
        multiplex: false,
      });

      this.socket.on('error', err => console.error(err));
      this.socket.on('msg:create', data => this.newMsg.next(data));
      this.socket.on('msg:delete', data => this.delMsg.next(data));
    }
  }

  disconnect() {
    if (this.socket && this.socket.connected) {
      this.newMsg.complete();
      this.newMsg = new Subject<GroupMsg>();
      this.socket.disconnect();
      this.socket = undefined;
    }
  }

  onNewMessage(group: ChatGroup) {
    return this.newMsg.pipe(
      filter(msg => msg.group.toString() === group._id.toString()),
      tap(msg => (msg.created_at = new Date(msg.created_at))),
    );
  }

  onDeleteMessage(group: ChatGroup) {
    return this.delMsg.pipe(
      filter(msg => msg.group_id === group._id.toString()),
      map(msg => msg.msg_id),
    );
  }
}
